import type { ReactNode } from 'react'
import { Link } from 'react-router-dom'
import { useIsAdmin } from './role'

/** Wraps pages editors can't open. The API refuses them too; this just explains it. */
export default function AdminOnly({ children }: { children: ReactNode }) {
  if (useIsAdmin()) return <>{children}</>
  return (
    <section className="max-w-[46ch]">
      <h2 className="font-serif text-[32px] leading-none font-medium">Admins only</h2>
      <p className="mt-4 text-copy">This part of the studio is for admins. Editors can write, edit and schedule posts.</p>
      <Link to="/admin" className="text-caps mt-6 inline-flex h-10 items-center bg-ink px-5 text-white hover:bg-rose">
        Back to dashboard
      </Link>
    </section>
  )
}
